import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const AnalysisDateIcon = createIcon({
  displayName: 'Analysis date',
  viewBox: '0 0 30 30',
  path: (
    <>
      <path d="M0 0h30v30H0z" fill="transparent" data-name="Rectangle 7194" />
      <path
        transform="translate(-642.15 -294.8)"
        d="m651.99 302.076-2.511.166-.793.971v13.953l.735.7 1.324.3h13.285s.859-.238.913-.258a7.473 7.473 0 0 0 .52-.574l.322-.854-.089-12.623-.322-1.133-.967-.555-1.5-.086z"
        fill="#e9f4ff"
      />
      <path transform="translate(3 3)" d="M0 0h24v24H0z" fill="none" />
      <path
        transform="translate(3 3)"
        d="M7 11h2v2H7zm14-5v14a2.006 2.006 0 0 1-2 2H5a2 2 0 0 1-2-2l.01-14A1.991 1.991 0 0 1 5 4h1V2h2v2h8V2h2v2h1a2.006 2.006 0 0 1 2 2zM5 8h14V6H5zm14 12V10H5v10zm-4-7h2v-2h-2zm-4 0h2v-2h-2z"
        fill="#2c93fa"
      />
    </>
  ),
})

export const TotalImagesLoadedIcon = createIcon({
  displayName: 'Total images loaded',
  viewBox: '0 0 30 30',
  path: (
    <g transform="translate(-492 -418)" data-name="Group 143480">
      <path
        transform="translate(492 418)"
        d="M0 0h30v30H0z"
        fill="transparent"
        data-name="Rectangle 7194"
      />
      <g transform="translate(433.8 265.82)">
        <path
          fill="#2c93fa"
          d="M81.61 160H64.652a.652.652 0 0 0-.652.652V173.7a.652.652 0 0 0 .652.652H81.61a.652.652 0 0 0 .652-.652v-13.048a.652.652 0 0 0-.652-.652zm-.81 12.882H65.468v-.813l2.823-3.349 3.059 3.628 4.759-5.642 4.686 5.556zm0-2.646-4.562-5.41a.162.162 0 0 0-.249 0l-4.635 5.5-2.935-3.479a.162.162 0 0 0-.249 0l-2.7 3.2v-8.575H80.8z"
          data-name="Path 22668"
        />
        <path
          fill="#d3e6fb"
          transform="translate(-70.532 -322.29)"
          d="m141.882 494.642-3.059-3.628-2.823 3.349v.813h15.328v-.62L146.642 489z"
          data-name="Path 22669"
        />
        <path
          fill="#d3e6fb"
          transform="translate(-70.532 -70.532)"
          d="m136 240.575 2.7-3.2a.162.162 0 0 1 .249 0l2.935 3.479 4.635-5.5a.162.162 0 0 1 .249 0l4.562 5.41V232H136zm3.424-7.6a1.794 1.794 0 1 1-1.794 1.794 1.794 1.794 0 0 1 1.794-1.791z"
          data-name="Path 22670"
        />
        <path
          transform="translate(-207.68 -176.33)"
          d="M276 340.571a.571.571 0 1 0 .571-.571.571.571 0 0 0-.571.571z"
          fill="#e6e6e6"
          data-name="Path 22671"
        />
        <path
          fill="#2c93fa"
          transform="translate(-148.9 -117.55)"
          d="M217.794 283.587a1.794 1.794 0 1 0-1.794-1.793 1.794 1.794 0 0 0 1.794 1.793zm0-2.364a.571.571 0 1 1-.571.571.57.57 0 0 1 .571-.571z"
          data-name="Path 22672"
        />
      </g>
    </g>
  ),
})

export const PageUrlLoadedIcon = createIcon({
  displayName: 'Page URL loaded',
  viewBox: '0 0 30 30',
  path: (
    <g transform="translate(-974 -294)" data-name="Group 143475">
      <path
        transform="translate(974 294)"
        d="M0 0h30v30H0z"
        fill="transparent"
        data-name="Rectangle 7195"
      />
      <rect
        transform="rotate(43 115.7 1409.3)"
        width="8"
        height="17"
        rx="4"
        fill="#e9f4ff"
        data-name="Rectangle 7393"
      />
      <g transform="translate(978.8 299.3)">
        <path
          fill="#2c93fa"
          transform="translate(0 1.406)"
          d="M5.61 6.956 3.693 8.874a4.194 4.194 0 0 0 5.93 5.926l2.555-2.556A4.193 4.193 0 0 0 11.021 5.5l-.819.819a1.4 1.4 0 0 0-.215.278 2.8 2.8 0 0 1 1.2 4.664l-2.551 2.556a2.8 2.8 0 0 1-3.955-3.956l1.108-1.107a5.616 5.616 0 0 1-.179-1.8z"
          data-name="Path 22659"
        />
        <path
          fill="#2c93fa"
          transform="translate(1.29)"
          d="M6.935 5.749A4.193 4.193 0 0 0 8.093 12.5l1.083-1.085a2.8 2.8 0 0 1-1.252-4.68l2.553-2.555a2.8 2.8 0 1 1 3.956 3.956l-1.108 1.107a5.623 5.623 0 0 1 .179 1.8l1.918-1.918a4.194 4.194 0 1 0-5.931-5.931z"
          data-name="Path 22660"
        />
      </g>
    </g>
  ),
})

export const TotalImagePayloadIcon = createIcon({
  displayName: 'Total image payload',
  viewBox: '0 0 30 30',
  path: (
    <g data-name="Group 143481">
      <path d="M0 0h30v30H0z" fill="transparent" data-name="Rectangle 7194" />
      <path
        transform="translate(-967.17 -409.35)"
        d="M989.543 422.435a2.283 2.283 0 0 0 .992.713c.457.072.946 1.081.946 1.081l.411 1.169v2.547l-.713 1.042-.645.448-1.4 1.282h-13.74v-.589l-1.746-.161-1.245-.981-.366-2.508 2.788-2.8 1.036-2.561 1.406-2.284h7.667l1.752 2.89h1.868z"
        fill="#e9f4ff"
        data-name="Path 22458"
      />
      <path
        transform="translate(3.619 2.901)"
        d="m16.5 9-.352.015A6.3 6.3 0 0 0 10.25 5 6.224 6.224 0 0 0 4 11v.126A4.876 4.876 0 0 0 1.25 15a4.225 4.225 0 0 0 4.25 4h11a5 5 0 0 0 0-10zm0 8H12v-3.794l2.146 2.146a.494.494 0 0 0 .354.146.5.5 0 0 0 .354-.853l-3-3-.164-.107a.5.5 0 0 0-.383 0l-.162.107-3 3a.5.5 0 0 0 .708.707L11 13.206V17H5.5a2 2 0 0 1-.092-4.005l1.422.015-.248-1.2a3.993 3.993 0 1 1 7.848-1.475l.187 1.1 1.073-.306A2.927 2.927 0 0 1 16.5 11a3 3 0 1 1 0 6z"
        fill="#2c93fa"
      />
    </g>
  ),
})

export const PossibleSavingsIcon = createIcon({
  displayName: 'Possible savings',
  viewBox: '0 0 30 30',
  path: (
    <g data-name="Group 143485">
      <path d="M0 0h30v30H0z" fill="transparent" data-name="Rectangle 7195" />
      <path
        transform="translate(-9.498 -3.349)"
        d="m28.518 11.968.8 1.464.843.732.808.622h1.489l-.23.7.23.51v4.315l-.176.615-.46.394-.718.313-2.586.046v4.779l-.379.487-.663.3-11.387-.3v-.886l-.389-.718V23.61l-.707-11.232.707-.41h.389l.9-.6 9.921-2.246 1.015.128h.6v2.714z"
        fill="#e9f4ff"
        data-name="Path 22459"
      />
      <path
        transform="translate(2 3)"
        d="M0 0h24v24H0z"
        fill="none"
        data-name="Rectangle 7395"
      />
      <g data-name="Group 144620">
        <path
          transform="translate(2 3)"
          d="M15 10a1 1 0 1 1 1 1 1 1 0 0 1-1-1zM8 9h5V7H8zm14-1.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5A5.5 5.5 0 0 1 7.5 4h5a5 5 0 0 1 4-2A1.5 1.5 0 0 1 18 3.5a1.4 1.4 0 0 1-.12.58 4.834 4.834 0 0 0-.32 1.15l2.27 2.27zm-2 2h-1L15.5 6a7.213 7.213 0 0 1 .26-1.91A3.016 3.016 0 0 0 13.67 6H7.5A3.5 3.5 0 0 0 4 9.5c0 1.88 1.22 6.65 2.01 9.5H8v-2h6v2h2.01l1.55-5.15 2.44-.82z"
          fill="#2c93fa"
          data-name="Path 22674"
        />
      </g>
    </g>
  ),
})
